import { render, staticRenderFns } from "./OrganizationsTable.vue?vue&type=template&id=6611f114&scoped=true&"
import script from "./OrganizationsTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6611f114",
  null
  
)

export default component.exports